import { QueryableEntityType } from 'mark43-federated-search';
import { useFederatedSearchQueryForms } from '../../federated-search/federated-search-context';
import { useCallback } from 'react';

export const useDexNextForms = () => {
    const { queryForms } = useFederatedSearchQueryForms();

    const getFormByEntityType = useCallback(
        (entityType: QueryableEntityType) =>
            queryForms.find((queryForm) => queryForm.queryableEntityType === entityType),
        [queryForms]
    );

    return {
        queryForms,
        getFormByEntityType,
    };
};
